import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { Credential } from '@nexla/@types';

export default function useCredentials() {
  const credentials = useSelector((state: any) => state.entities.credentials);

  const credentialsById = useSelector((state: any) => state.credentials.byId);

  const credentialsIdsByType = useSelector((state: any) => state.credentials.byType);

  const getAvailableCredentialsOfType = useCallback(
    (credentialsType: string, existingCredentials: Credential[] = []): Credential[] => {
      if (!credentials || !credentialsIdsByType) return [];

      const allCredentialsOfType = credentialsIdsByType[credentialsType] || [];

      const existingCredentialIds = new Set(existingCredentials.map((cred) => cred.id));

      // filter credential IDs to exclude existing ones, then map to credential entities
      const availableCredentials = allCredentialsOfType
        .filter((credId) => !existingCredentialIds.has(credId))
        .map((credId) => credentials[credId])
        .filter(Boolean);

      return availableCredentials;
    },
    [credentials, credentialsIdsByType],
  );

  return {
    credentials,
    credentialsById,
    getAvailableCredentialsOfType,
  };
}
